import type { SummaryParams } from "./api";

export const stagingsKeys = {
  all: ["stagings"] as const,
  lists: () => [...stagingsKeys.all, "list"] as const,
  // The status set is part of the key because the list is filtered on the
  // server: two selections return different rows under the same search.
  list: (search: string, statuses: number[] = []) =>
    [...stagingsKeys.lists(), { search, statuses }] as const,
  summaries: () => [...stagingsKeys.all, "summary"] as const,
  summary: (params: SummaryParams) => [...stagingsKeys.summaries(), params] as const,
  details: () => [...stagingsKeys.all, "detail"] as const,
  detail: (id: number | null) => [...stagingsKeys.details(), id] as const,
};
